import React from 'react';
import { TabsWrapper, TabButton, TabIcon, TabLabel } from './HeaderTabs.styles.ts';
import { LuBookOpen, LuUsers, LuMail } from 'react-icons/lu';
import { PiGraduationCapDuotone, PiLifebuoyDuotone } from 'react-icons/pi';

const tabs = [
  {
    label: 'My Courses',
    icon: <LuBookOpen size={22} />,
    active: true,
  },
  {
    label: 'Learning Resources',
    icon: <PiGraduationCapDuotone size={22} />,
  },
  {
    label: 'Student Life',
    icon: <LuUsers size={22} />,
  },
  {
    label: 'Support',
    icon: <PiLifebuoyDuotone size={22} />,
  },
  {
    label: 'Contact',
    icon: <LuMail size={22} />,
  },
];

type HeaderTabsProps = {
  vertical?: boolean;
  onSelect?: () => void;
};

const HeaderTabs: React.FC<HeaderTabsProps> = ({ vertical = false, onSelect }) => {
  return (
    <TabsWrapper $vertical={vertical}>
      {tabs.map((tab) => (
        <TabButton
          key={tab.label}
          $active={!!tab.active}
          $vertical={vertical}
          onClick={onSelect}
        >
          <TabIcon>{tab.icon}</TabIcon>
          <TabLabel>{tab.label}</TabLabel>
        </TabButton>
      ))}
    </TabsWrapper>
  );
};

export default HeaderTabs;
